import { getBenefitStatus, getCheckoutUrlV2, getRecurrenceStatus } from "../api/smartcheckout";

const getSmartcheckoutUrlV2 = async (msisdn, channel, recipient, productId, origin) => {
  const response = await getCheckoutUrlV2(msisdn, {
    msisdn,
    channel,
    recipient,
    productId,
    origin,
  });

  return response;
};

const getSmartcheckoutBenefitStatus = async (identifier, correlationId) => {
  return getBenefitStatus(identifier, correlationId);
};

const getSmartcheckoutRecurrenceStatus = async (identifier, correlationId) => {
  return getRecurrenceStatus(identifier, correlationId);
};

export { getSmartcheckoutUrlV2, getSmartcheckoutBenefitStatus, getSmartcheckoutRecurrenceStatus };
